export const listOfWeeks = [
    {
        id: 1, day: "Sun"
    },
    {
         id: 2, day: "Mon"
    },
    {
        id: 3, day: "Tue"
   },
   {
       id: 4, day: "Wed"
   },
   {
    id: 5, day: "Thu"
   },
   {
    id: 6, day: "Fri"
   },
   {
    id: 7, day: "Sat"
   }
]

export const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];